/* eslint-disable max-len */
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Analytics from "./page/Analytics";
import Index from "./page/Index";
import Survey from "./page/Survey";
import Survey2 from "./page/Survey2";

export const UNDEFINED = 0;
export const ZERO = 0;
export const ONE = 1;
export const ONE_DECIMAL = 10;
export const TWO_DECIMAL = 100;
export const HUNDRED = 100;
export const NUMBER_OF_DAYS_IN_WEEK = 7;

/**
 * App
 *
 * @constructor
 */
function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Index />} />
				<Route
					path="/survey/:publicationId/:name"
					element={<Survey />}
				/>
				<Route
					path="/survey2/:publicationId/:name"
					element={<Survey2 />}
				/>
				<Route
					path="/analytics/:publicationId/:avgUniqueVisitors/:avgDocVisits/:avgPagesPerVisit/:avgVisitTime/:publicationTotalPages"
					element={<Analytics />}
				/>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
